"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18nTestInstance = void 0;
const tslib_1 = require("tslib");
const i18next_1 = tslib_1.__importDefault(require("i18next"));
const react_i18next_1 = require("react-i18next");
function i18nTestInstance() {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        yield i18next_1.default.use(react_i18next_1.initReactI18next).init({
            resources: {
                en: { translation: {} },
                fr: { translation: {} },
            },
            fallbackLng: "en",
            lng: "en",
            ns: ["translations"],
            defaultNS: "translations",
            supportedLngs: ["en", "fr"],
            react: {
                useSuspense: false,
            },
        });
        return i18next_1.default;
    });
}
exports.i18nTestInstance = i18nTestInstance;
//# sourceMappingURL=I18n.js.map